import React from 'react';
import './PageHeader.styles.less';

const PageHeader = () => (
  <React.Fragment>
    <div className="mpr-pages-header">
      <div className="mpr-pages-header__group">
        <h1 className="mpr-pages-header__title">Pages</h1>
      </div>
    </div>
    <div className="mpr-pages-labels">
      <span className="mpr-pages-labels__reorder-label">Reorder</span>
      <span className="mpr-pages-labels__page-label">
        Page
      </span>
      <span className="mpr-pages-labels__enabled-label">
        Enabled
        <div className="with-tooltip mpr-pages-labels__enabled-label-tooltip" data-tooltip="Enabled pages are visible to your guests when your website is published">
          <i className="zolaicon zolaicon-info mpr-page-list-item__publish-registry__icon" />
        </div>
      </span>
      <span className="mpr-pages-labels__status-label">Status</span>
    </div>
  </React.Fragment>
);


export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/Pages/PageHeader/PageHeader.jsx